import React from 'react';
import { motion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  y?: number;
  className?: string;
}
export function Reveal({
  children,
  delay = 0,
  y = 14,
  className = ''
}: RevealProps) {
  return <motion.div initial={{
    opacity: 0,
    y,
    filter: 'blur(4px)'
  }} animate={{
    opacity: 1,
    y: 0,
    filter: 'blur(0px)'
  }} transition={{
    delay,
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1]
  }} className={className} data-id="element-280" data-mp="3bie7ltbmf3qp">
      {children}
    </motion.div>;
}